import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// jsonLd: array of schema objects to inject as <script type="application/ld+json">
const SEO = ({ title, description, keywords, canonical, ogImage, jsonLd }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (selector, content) => {
      const el = document.querySelector(selector);
      if (el && content) el.setAttribute('content', content);
    };

    setMeta('meta[name="description"]', description);
    setMeta('meta[name="keywords"]', keywords);
    setMeta('meta[property="og:title"]', title);
    setMeta('meta[property="og:description"]', description);
    setMeta('meta[property="og:url"]', canonical);
    if (ogImage) setMeta('meta[property="og:image"]', ogImage);
    setMeta('meta[name="twitter:title"]', title);
    setMeta('meta[name="twitter:description"]', description);
    setMeta('meta[name="twitter:url"]', canonical);

    // Canonical
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }

    // Remove previously injected JSON-LD scripts
    document.querySelectorAll('script[data-dynamic-jsonld]').forEach(s => s.remove());

    // Inject new JSON-LD schemas
    if (jsonLd && jsonLd.length > 0) {
      jsonLd.forEach(schema => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-dynamic-jsonld', 'true');
        script.textContent = JSON.stringify(schema);
        document.head.appendChild(script);
      });
    }
  }, [title, description, keywords, canonical, ogImage, jsonLd, location]);

  return null;
};

export default SEO;
